// TOP LEVEL IMPORTS
import React from 'react';
//
import CurrencyInput from '../CurrencyInput';

class MoneyInput extends React.PureComponent {
  render() {
    console.log(this.props.value);
    return (
      <span className="ant-input-group-wrapper ant-input-group-wrapper-lg" style={{ width: '100%', marginRight: 8 }}>
        <span className="ant-input-wrapper ant-input-group">
          <span className="ant-input-group-addon">{this.props.currencySymbol ? this.props.currencySymbol : '$'}</span>
          <CurrencyInput
            className="ant-input ant-input-lg"
            value={this.props.value}
            placeholder={this.props.placeholder || 'amount'}
            onChangeEvent={e => this.props.onChange(e.target.value)}
          />
        </span>
      </span>
    );
  }
}

export default MoneyInput;



// WEBPACK FOOTER //
// ./src/components/inputs/MoneyInput/index.js